import { render, staticRenderFns } from "./HolidayPanel.vue?vue&type=template&id=118c7df3&scoped=true"
import script from "./HolidayPanel.vue?vue&type=script&lang=js"
export * from "./HolidayPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118c7df3",
  null
  
)

export default component.exports